import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, LinkedinIcon } from 'lucide-react';
interface OurTeamProps {
  onContactOpen: () => void;
}
interface TeamMember {
  id: string;
  name: string;
  title: string;
  role: string;
  image: string;
  bio: string;
  linkedin?: string;
}
const teamMembers: TeamMember[] = [{
  id: 'dj',
  name: 'DJ Panfili',
  title: 'Founder & CEO',
  role: 'Management',
  image: 'https://cdn.magicpatterns.com/uploads/o8LfULY8SjUCiYkiUGjHZD/DJ_Headshot_5.png',
  bio: "As a second-time founder, DJ Panfili has spent his career generating predictable revenue through growth marketing strategy. Before founding Deal Flow, he built end-to-end client acquisition systems that drove over $35 million in attributable revenue, including leading demand generation for the world's largest neuroscience-based research and training organization. Today, DJ applies that same data-driven marketing rigor to lower middle-market M&A. He leads Deal Flow's go-to-market strategy, replacing broker-dependent sourcing with proprietary, off-market deal flow. He built this firm to solve the biggest bottleneck in private equity—consistent access to off market seller opportunities. He's focused on delivering a better M&A experience for both buyers and sellers, removing friction for buyers and ensuring founders receive a fundamentally better exit experience.",
  linkedin: 'https://www.linkedin.com/in/gaeton-panfili-041937271/'
}, {
  id: 'ciaran',
  name: 'Ciaran Houlihan',
  title: 'COO & Co-Founder',
  role: 'Management',
  image: 'https://cdn.magicpatterns.com/uploads/1DfaFXLotCKSWjjthbHQxw/Aragon-Headshot-Ciaran-Houlihan-2026-02-26-19.jpg',
  bio: 'A serial entrepreneur and systems architect, Ciaran Houlihan builds AI-driven, off-market deal sourcing engines. After launching his first business at 17 and scaling it to a 7-figure run rate in under 2 years, he scaled his most recent B2B marketing agency, Customers on Command, to a $2.5M run rate in just 12 months. Today, as COO of Deal Flow, Ciaran oversees the operational infrastructure that replaces broker dependency with predictable, data-driven deal flow. Having worked alongside dozens of founders navigating high-stakes transitions, Ciaran ensures that every exit is executed with institutional-grade efficiency and precision.',
  linkedin: 'https://www.linkedin.com/in/ciaranhoulihan/'
}, {
  id: 'devesh',
  name: 'Devesh Sharma',
  title: 'Managing Director',
  role: 'Management',
  image: 'https://cdn.magicpatterns.com/uploads/twsLpeFX4wQvVeLXZ1AZzv/Devesh-pic_v2.jpg',
  bio: 'Devesh is a veteran operator and M&A strategist who brings the rigor of multi-billion-dollar conglomerates to the lower middle market. Over a 25-year career, he has engineered more than 100 acquisitions worth over $3 billion. As SVP of M&A at Bosch ($90B revenue), he completed 100s of transactions with an average enterprise value of $300M, and as SVP of Finance, he oversaw a $2.5 billion division. He later served as SVP of Strategy at Commercial Metals Company (NYSE: CMC, $9B revenue), capturing over $100M in operational savings, before spending a decade as a Private Equity Operating Partner managing $300M in AUM and achieving 30%+ IRRs. Devesh specializes in identifying and eliminating the hidden weaknesses that buyers use to discount valuations. His signature approach was recently proven when he took a company with a stalled $90M deal and orchestrated a $275M close. At Deal Flow, Devesh leverages his deep operational background in manufacturing and business services to ensure our clients achieve maximum enterprise value and never leave money on the table.',
  linkedin: 'https://www.linkedin.com/in/deveshsharma1/'
}, {
  id: 'rick',
  name: 'Rick Segal',
  title: 'Advisor',
  role: 'Advisory Board',
  image: 'https://cdn.magicpatterns.com/uploads/mCdUUEuMn1eiHbReNUD5Eg/Rick_Segal_Headshot.jpg',
  bio: 'Rick brings over 40 years of institutional investment expertise to Deal Flow, having built and managed multi-billion-dollar portfolios. As the Founder and CEO of Rethink Capital Partners, he grew the firm to $2.2 billion in assets under management (AUM), and as President of the Segal Family Office and Managing Partner of Banyan Seed Ventures, he has deployed capital across private equity, real estate, and venture capital since 1981. Rick has served on the boards of dozens of public and private companies, including Hudson General Inc., Air Express Int., Penn Traffic Company, Schoolnet (acquired by Pearson for $230M), Wireless Generation (acquired by News Corp for $360M), Smarterer (acquired by Pluralsight), Flocabulary (acquired by Nearpod), Civitas Learning, Vivvi, Knowledge to Practice, BEGiN, Orijin, Voxy, EnGen, Noodle Companies, and Cinematic Health Education. A recognized pioneer in impact investing and author of The Heart of It, Rick leverages his deep institutional network and M&A experience to advise Deal Flow on firm strategy.',
  linkedin: 'https://www.linkedin.com/in/rick-segal-b0167310/'
}, {
  id: 'nick',
  name: 'Nick Eubanks',
  title: 'Advisor',
  role: 'Advisory Board',
  image: 'https://cdn.magicpatterns.com/uploads/vhQou8RoRpqrs5RLfmoJhs/thumb_Nick_Headshot.jpg',
  bio: "Nick is a serial entrepreneur, digital strategist, and SEO pioneer who has driven over 100 billion organic visits and $100 billion in online revenue for global brands. He currently serves as the Global Chief Marketing Officer at Digistore24, a $3 billion-a-year global affiliate network and online sales platform. Prior to this, Nick served as Vice President of Owned Media at Semrush (NYSE: SEMR), managing world-class growth teams and leading major acquisitions like ExplodingTopics and Search Engine Land. He joined Semrush following their $1.8 million acquisition of Traffic Think Tank, the #1 private SEO training community he co-founded. Nick also founded and successfully exited From The Future, a premier performance marketing agency whose client roster included the U.S. Olympics, UFC, Sandals Resorts, and the NBA. With a career spanning multiple successful exits and executive roles, Nick's playbooks for content flywheels, organic demand capture, and data-layer monetization inform Deal Flow's long-term moat: turning every seller interaction into proprietary insight. Nick guides our brand authority, inbound deal flow, and overall digital strategy.",
  linkedin: 'https://www.linkedin.com/in/nickeubanks/'
}, {
  id: 'elliot',
  name: 'Elliot Martinez',
  title: 'Strategic Partner',
  role: 'Advisory Board',
  image: 'https://cdn.magicpatterns.com/uploads/sF1aLoJJcq5sFPYAF84wTE/thumb_Elliiot_Headshot.jpg',
  bio: "Elliot is a deal-maker who has executed $250M in private-sector transactions spanning real estate, healthcare, and lower-middle-market roll-ups. Formerly a commercial real-estate principal, he now advises PE operators on capital structuring, lender relations, and post-close value creation. Elliot's superpower is assembling the right people around the right opportunity — accelerating diligence, funding, and operational lift-off. His people-over-profits ethos keeps culture and returns aligned, making him an invaluable compass as we scale from agency to tech-enabled investment platform.",
  linkedin: 'https://www.linkedin.com/in/elliot-martinez-4b93711b7/'
}];
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6,
    ease: 'easeOut'
  }
};
export function OurTeam({
  onContactOpen
}: OurTeamProps) {
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);
  const managementTeam = teamMembers.filter(m => m.role === 'Management');
  const advisoryBoard = teamMembers.filter(m => m.role === 'Advisory Board');
  const renderGrid = (members: TeamMember[], bg: string) => <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.06]" data-id="element-579">
      {members.map((member, index) => <motion.div key={member.id} {...fadeInUp} transition={{
      duration: 0.6,
      delay: index * 0.1
    }} onClick={() => setSelectedMember(member)} className={`group cursor-pointer ${bg}`} data-id="element-580">
          <div className="relative overflow-hidden" data-id="element-581">
            <img src={member.image} alt={member.name} className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0" data-id="element-582" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" data-id="element-583" />
            <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-584">
              <h3 className="text-lg font-bold text-white" data-id="element-585">{member.name}</h3>
              <p className="text-white/50 text-xs mt-0.5" data-id="element-586">{member.title}</p>
            </div>
          </div>
          <div className="p-6 border-t border-white/[0.06]" data-id="element-587">
            <span className="text-deal-green text-xs font-medium tracking-wide group-hover:underline" data-id="element-588">
              Read Bio →
            </span>
          </div>
        </motion.div>)}
    </div>;
  return <main className="bg-deal-black pt-20" data-id="element-589">
      {/* Page Header */}
      <section className="py-20 md:py-28 border-b border-white/[0.06]" data-id="element-590">
        <div className="max-w-6xl mx-auto px-6 lg:px-10" data-id="element-591">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-592">
            <span className="inline-block text-deal-green text-[11px] font-semibold tracking-[0.25em] uppercase mb-6 border border-deal-green/30 px-4 py-1.5" data-id="element-593">
              Our Team
            </span>
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight" data-id="element-594">
            The People Behind
            <br data-id="element-595" />
            <span className="text-deal-green" data-id="element-596">Your Exit.</span>
          </motion.h1>
        </div>
      </section>

      {/* Management Team */}
      <section className="py-20 md:py-28 bg-[#0d0d0d]" data-id="element-597">
        <div className="max-w-6xl mx-auto px-6 lg:px-10" data-id="element-598">
          <motion.div {...fadeInUp} className="mb-12" data-id="element-599">
            <p className="text-[11px] text-deal-green tracking-[0.25em] uppercase font-semibold" data-id="element-600">
              Management Team
            </p>
            <div className="w-8 h-px bg-deal-green/40 mt-3" data-id="element-601" />
          </motion.div>
          {renderGrid(managementTeam, 'bg-[#0d0d0d]')}
        </div>
      </section>

      {/* Advisory Board */}
      <section className="py-20 md:py-28 bg-deal-black" data-id="element-602">
        <div className="max-w-6xl mx-auto px-6 lg:px-10" data-id="element-603">
          <motion.div {...fadeInUp} className="mb-12" data-id="element-604">
            <p className="text-[11px] text-deal-green tracking-[0.25em] uppercase font-semibold" data-id="element-605">
              Advisory Board
            </p>
            <div className="w-8 h-px bg-deal-green/40 mt-3" data-id="element-606" />
          </motion.div>
          {renderGrid(advisoryBoard, 'bg-deal-black')}
        </div>
      </section>

      {/* Bio Modal */}
      <AnimatePresence data-id="element-607">
        {selectedMember && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm" onClick={() => setSelectedMember(null)} data-id="element-608">
            <motion.div initial={{
          opacity: 0,
          scale: 0.97,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.97,
          y: 20
        }} transition={{
          duration: 0.3,
          type: 'spring',
          damping: 25
        }} className="relative w-full max-w-3xl max-h-[90vh] overflow-y-auto bg-[#111111] border border-white/10 shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-609">
              <button onClick={() => setSelectedMember(null)} className="absolute top-6 right-6 p-2 text-white/30 hover:text-white transition-colors z-10" aria-label="Close modal" data-id="element-610">
                <XIcon className="w-5 h-5" data-id="element-611" />
              </button>
              <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-612">
                <div className="md:col-span-1" data-id="element-613">
                  <img src={selectedMember.image} alt={selectedMember.name} className="w-full h-64 md:h-full object-cover grayscale" data-id="element-614" />
                </div>
                <div className="md:col-span-2 p-8 md:p-10" data-id="element-615">
                  <span className="text-deal-green text-[10px] font-semibold tracking-[0.2em] uppercase" data-id="element-616">
                    {selectedMember.title}
                  </span>
                  <h2 className="text-2xl font-bold text-white mt-2 mb-1" data-id="element-617">
                    {selectedMember.name}
                  </h2>
                  <div className="w-8 h-px bg-deal-green mt-4 mb-6" data-id="element-618" />
                  <p className="text-white/55 leading-relaxed text-sm mb-8" data-id="element-619">
                    {selectedMember.bio}
                  </p>
                  {selectedMember.linkedin && <a href={selectedMember.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-deal-green hover:text-deal-green-dark transition-colors text-sm" data-id="element-620">
                      <LinkedinIcon className="w-4 h-4" data-id="element-621" />
                      <span data-id="element-622">Connect on LinkedIn</span>
                    </a>}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* CTA Section */}
      <section className="py-28 md:py-36 bg-[#0d0d0d] relative overflow-hidden" data-id="element-623">
        <div className="absolute inset-0 bg-gradient-to-t from-deal-green/[0.04] to-transparent" data-id="element-624" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10 text-center" data-id="element-625">
          <motion.div {...fadeInUp} data-id="element-626">
            <p className="text-[11px] text-deal-green tracking-[0.25em] uppercase font-semibold mb-6" data-id="element-627">
              Get Started
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-628">
              Meet the Team In Person
            </h2>
            <div className="w-12 h-px bg-deal-green/40 mx-auto mb-8" data-id="element-629" />
            <p className="text-lg text-white/45 mb-12 max-w-2xl mx-auto font-light" data-id="element-630">
              Schedule a confidential consultation and let us show you how our
              unique team can deliver the exit you deserve.
            </p>
            <button onClick={onContactOpen} className="px-8 py-4 bg-deal-green text-black text-sm font-bold tracking-widest uppercase hover:bg-deal-green-dark transition-colors duration-300" data-id="element-631">
              Schedule a Consultation
            </button>
          </motion.div>
        </div>
      </section>
    </main>;
}